export default __webpack_public_path__ + "static/larar-forlaget-logo-9b90c2e952a2f21090a424383e088824.svg";